import { render, staticRenderFns } from "./CreativeColumn.vue?vue&type=template&id=4550ef6d&"
import script from "./CreativeColumn.vue?vue&type=script&lang=js&"
export * from "./CreativeColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports